import Image from "next/legacy/image";
import { addTrailingSlash } from '@utils';

export interface CoverImageProps {
  title?: string | null;
  coverImage?: string | { sourceUrl?: string | null | undefined } | null;
  href?: string;
  large?: boolean;
}

export const CoverImage: React.FC<CoverImageProps> = ({
  title,
  coverImage,
  href,
  large,
}) => {
  const image = (
    <Image
      width={612}
      height={344}
      layout='responsive'
      sizes={
        large
          ? '(min-width: 768px) 684px, 100vw'
          : '(min-width: 768px) 328px, 100vw'
      }
      objectFit='cover'
      alt={`Cover Image for ${title}`}
      src={
        (typeof coverImage === 'string' ? coverImage : coverImage?.sourceUrl) ||
        ''
      }
      className={`shadow-small ${
        href ? 'transition-shadow duration-200 hover:shadow-medium' : ''
      }`}
    />
  );
  return (
    <div className='sm:mx-0'>
      {href ? (
        /* prefetchさせない/spa動作させないためにnext/linkを使わない */
        (<a href={addTrailingSlash(href)} aria-label={title || undefined}>
          {image}
        </a>)
      ) : (
        image
      )}
    </div>
  );
};
